import { Box, Typography, Button, useTheme } from '@mui/material';
import Header from '@/Components/MagicLink/Header';
import WarningIcon from '@/Components/MagicLink/WarningIcon';
import Section from '@/Components/MagicLink/Section';
import MagicLinkActionBar from '@/Components/MagicLink/MagicLinkActionBar';
import { useMagicLinkAppProvider, MagicLinkView } from '@/Provider/MagicLinkAppProvider';
import {
    magicLinkCenteredHeroInnerSx,
    magicLinkPageColumnSx,
    magicLinkPageOuterSx,
} from '@/Utils/MagicLink/pageLayout';

const InvalidIdCardView = () => {
    const theme = useTheme();
    const { navigateToView, validationErrorMessage } = useMagicLinkAppProvider();

    return (
        <Box component="main" sx={magicLinkPageOuterSx}>
            <Box sx={magicLinkPageColumnSx}>
                    {/* Centered status block — logo is rendered directly above the
                        Section card and shares the card's left edge so the two read as
                        a single grouped unit. */}
                    <Box sx={magicLinkCenteredHeroInnerSx}>
                        <Box
                            sx={{
                                width: '100%',
                                maxWidth: 480,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                            }}
                        >
                            <Header />

                            <Section>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        gap: 2,
                                        paddingY: 1,
                                    }}
                                >
                                    <WarningIcon height={60} width={64} />
                                    <Typography variant="h5" component="h1" color={theme.palette.error.dark}>
                                        Neplatný občiansky preukaz
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {validationErrorMessage || 'Občiansky preukaz nie je platný. Skúste to znova.'}
                                    </Typography>
                                </Box>
                            </Section>
                        </Box>
                    </Box>

                    <MagicLinkActionBar
                        primary={
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => navigateToView(MagicLinkView.CAMERA)}
                                sx={{
                                    textTransform: 'none',
                                    height: '55px',
                                    fontWeight: 500,
                                }}
                            >
                                Nahrať znova
                            </Button>
                        }
                    />
            </Box>
        </Box>
    );
};

export default InvalidIdCardView;
